module.exports = __webpack_public_path__ + "static/media/DOT-GA-US-Logo-2018 1.12c18b5c.png";